/**
 * Utilitaire pour initialiser les icônes Lucide de manière sécurisée
 */
import { createIcons, icons } from 'lucide';
import { logger } from './ProfessionalLogger';

/**
 * Initialise les icônes Lucide de manière sécurisée avec fallback
 */
export function initializeLucideIconsSafely(): void {
  try {
    // Vérifier que createIcons est disponible
    if (typeof createIcons === 'function') {
      createIcons({ icons });
      logger.info('✅ Icônes Lucide initialisées');
    } else {
      logger.warn("⚠️ createIcons n'est pas disponible, tentative avec window.lucide...");
      // Fallback vers window.lucide si disponible
      if (window.lucide && typeof window.lucide.createIcons === 'function') {
        window.lucide.createIcons({ icons: window.lucide.icons });
        logger.info('✅ Icônes Lucide initialisées via window.lucide');
      } else {
        logger.warn("⚠️ Lucide n'est pas disponible, les icônes seront initialisées plus tard");
      }
    }
  } catch (error) {
    const errorMessage = error instanceof Error ? error.message : String(error);
    logger.error(`Erreur lors de l'initialisation des icônes: ${errorMessage}`);
    // Ne pas bloquer l'initialisation de l'application
    // Essayer avec window.lucide en fallback
    try {
      if (window.lucide && typeof window.lucide.createIcons === 'function') {
        window.lucide.createIcons({ icons: window.lucide.icons });
        logger.info('✅ Icônes Lucide initialisées via fallback window.lucide');
      }
    } catch (_fallbackError) {
      logger.warn(
        "⚠️ Impossible d'initialiser les icônes Lucide, l'application continuera sans icônes"
      );
    }
  }
}
